// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"d72ff6d7","118":"1c7c6c3b","537":"ac42d526"}[chunkId] + ".css";
};